import _objectSpread from "C:\\projects\\grocery-go\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\projects\\grocery-go\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import { useContext } from 'react';
import Collapse from './Collapse';
import { useBootstrapPrefix } from './ThemeProvider';
import NavbarContext from './NavbarContext';
import { jsx as _jsx } from "react/jsx-runtime";
var NavbarCollapse = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      bsPrefix = _ref.bsPrefix,
      props = _objectWithoutProperties(_ref, ["children", "bsPrefix"]);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'navbar-collapse');
  var context = useContext(NavbarContext);
  return /*#__PURE__*/_jsx(Collapse, _objectSpread({
    in: !!(context && context.expanded)
  }, props, {
    children: /*#__PURE__*/_jsx("div", {
      ref: ref,
      className: bsPrefix,
      children: children
    })
  }));
});
NavbarCollapse.displayName = 'NavbarCollapse';
export default NavbarCollapse;